import React, { useEffect } from 'react';
import '../../styles/Home/ClientsLogos.css';

const ClientsLogos = () => {
  // Client logos with company names
  const clientLogos = [
    { id: 1, name: 'Infosys' },
    { id: 2, name: 'Wipro' },
    { id: 3, name: 'Capgemini' },
    { id: 4, name: 'T-Systems' },
    { id: 5, name: 'TCS' },
    { id: 6, name: 'Accenture' },
    { id: 7, name: 'IBM' },
    { id: 8, name: 'Microsoft' },
    { id: 9, name: 'Google Cloud' },
    { id: 10, name: 'Amazon AWS' }
  ];

  // Duplicate logos for infinite scroll effect
  const duplicatedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

  return (
    <section className="clients-logos-section">
      <div className="container">
        <div className="section-header text-center mb-6">
          <span className="section-label">Trusted By</span>
          <h2 className="section-title">Our Valued Clients</h2>
          <p className="section-subtitle">
            We are proud to partner with industry leaders and innovative companies
          </p>
        </div>

        {/* Infinite Scroll Logos */}
        <div className="logos-container">
          <div className="logos-track">
            {duplicatedLogos.map((client, index) => (
              <div 
                className="logo-item" 
                key={`${client.id}-${index}`}
                data-name={client.name}
              >
                <div className="logo-wrapper">
                  <div className="logo-placeholder">
                    <span className="logo-text">{client.name}</span>
                  </div>
                  <div className="logo-hover">
                    <span>{client.name}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Static Grid for Mobile */}
        <div className="logos-grid">
          {clientLogos.map((client) => (
            <div className="logo-grid-item" key={client.id}>
              <div className="logo-grid-wrapper">
                <span className="logo-grid-text">{client.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsLogos;